<template>
  <div class="atb-wrapper">
    <main-header></main-header>
    <main-content></main-content>
    <el-dialog title="修改密码" v-if="showModifyPwd" :visible.sync="showModifyPwd" width="500px" custom-class="change-initial-dialog" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content write-summary">
        <div class="initial-password">您的初始密码是 {{ initialPwd }}，请修改密码</div>
        <el-form ref="pwdForm" :model="modifyform" :rules="modifyPwdFormRules" label-width="100px" label-position="right" >
          <el-form-item label="新密码:" prop="newPassword">
            <el-input v-model.trim="modifyform.newPassword" type="password" autocomplete="off" clearable></el-input>
          </el-form-item>
          <el-form-item label="确认新密码:" prop="checkPassword">
            <el-input v-model.trim="modifyform.checkPassword" type="password" autocomplete="off" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="modifySubmit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import MainHeader from './MainHeader'
import MainContent from './MainContent'
export default {
  components: {
    MainHeader,MainContent
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value === this.initialPwd) {
        callback(new Error('新密码不能和初始密码一样'));
      } else {
        if (this.modifyform.checkPassword !== '') {
          this.$refs.pwdForm.validateField('checkPassword');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.modifyform.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var validateRule=(rule,value, callback)=>{
      // const pawRule= /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/;
      const pawRule = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?])\S{8,}$/;
      if(!pawRule.test(value)){
        callback(new Error('密码中必须包含数字、大小写字母、特殊字符，并且不能少于8位。'));
      }else{
        callback();
      }
    }
    return {
      modifyPwdFormRules:{
        newPassword: [
          { required: true, validator: validatePass, trigger: 'blur' },
          { required: true, validator: validateRule, trigger: 'blur' }
        ],
        checkPassword: [
          { required: true, validator: validatePass2, trigger: 'blur' },
          { required: true, validator: validateRule, trigger: 'blur' }
        ]
      },
      modifyform: {},
      showModifyPwd: false,
      initialPwd: ''
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getInitial();
    });
  },
  methods: {
    getInitial() {
      this.$ajax.get(this.$api.common.initial).then((res) => {
        if (res.data.isInitial) {
          this.showModifyPwd = true;
          this.initialPwd = res.data.initialPWD;
        }
      });
    },
    modifySubmit(){
      this.$refs.pwdForm.validate((valid) => {
         if (valid) {
          const { newPassword } = this.modifyform;
          this.$ajax.post(this.$api.common.changepwd, {currentPassword: this.initialPwd, newPassword}, {ignore: true}).then((res) => {
            console.log(res);
            if ( res.data.succeeded ) {
              this.showModifyPwd = false;
              this.$message.success('保存成功');
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
  }
}
</script>
<style scoped>
.atb-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}

</style>
<style lang="scss">
.change-initial-dialog {
  .initial-password {
    margin-bottom: 20px;
    padding-left: 12px;
  }
}
</style>